'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _specialties = require('./specialties.html');

var _specialties2 = _interopRequireDefault(_specialties);

var _specialties3 = require('./specialties.controller');

var _specialties4 = _interopRequireDefault(_specialties3);

require('./specialties.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialtiesComponent = {
  restrict: 'E',
  bindings: {},
  template: _specialties2.default,
  controller: _specialties4.default,
  controllerAs: 'vm'
};

exports.default = specialtiesComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/specialties/specialties.component.js